import { AfterViewInit, Directive } from '@angular/core';
import Inputmask from 'inputmask';
import { DatePicker } from 'primeng/datepicker';

@Directive({
  selector: '[allowedKeysToDatePicker]',
  standalone: false,
})
export class AllowedKeysToDatePickerDirective implements AfterViewInit {
  constructor(private primeCalendar: DatePicker) {}

  ngAfterViewInit() {
    new Inputmask(this.getDateMask()).mask(this.getHTMLInput());
  }

  getHTMLInput(): HTMLInputElement {
    return this.primeCalendar.el.nativeElement.querySelector('input');
  }

  getDateMask(): string {
    return '99/99/9999';
  }

  // @HostListener('keydown', ['$event'])
  // onKeyPress(event: KeyboardEvent) {
  //   const key = event.key.toLocaleLowerCase();

  //   if (
  // 		key !== 'tab' &&
  //     key !== 'backspace' &&
  //     key !== 'delete' &&
  //     key !== 'arrowleft' &&
  //     key !== 'arrowright' &&
  //     (key < '0' || key > '9') &&
  //     key !== '/'
  //   ) {
  //     event.preventDefault();
  //     event.stopPropagation();
  //   }
  // }
}
